module.exports = {
      id: "marker--track-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "images/sprites/ui.svg#marker--track-usage",
      toString: function () {
        return this.url;
      }
    }